(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["volantero-shipping-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('volantero-shipping-status')) {
    customElements.define('volantero-shipping-status', class extends HTMLElement {
      connectedCallback() { this.updateDate(); }
      updateDate() {
        const parts = new Intl.DateTimeFormat('en-AU', { timeZone:'Australia/Sydney', year:'numeric', month:'2-digit', day:'2-digit' }).formatToParts(new Date());
        const value = type => parts.find(part => part.type === type).value;
        const target = new Date(Date.UTC(Number(value('year')), Number(value('month')) - 1, Number(value('day')) + 1));
        const label = new Intl.DateTimeFormat('en-AU', { timeZone:'UTC', weekday:'short', day:'numeric', month:'short' }).format(target).replace(',', '');
        const time = this.querySelector('[data-dispatch-date]');
        if (time) { time.textContent = label; time.dateTime = target.toISOString().slice(0,10); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
